import React from "react";
import { useField, useFormikContext } from "formik";
import { Input, InputProps } from "reactstrap";
import { FormFieldRow } from "../misc/formFieldRow";

interface FormNumberRowProps extends Omit<InputProps, "name" | "type"> {
    name: string;
    label: string;
    hidden?: boolean;
    required?: boolean;
}

export const FormNumberRow = (props: FormNumberRowProps) => {
    const [field, meta] = useField<number | string | undefined>(props.name);
    const { submitCount } = useFormikContext();
    const showError = meta.touched || submitCount > 0;
    const error =
        showError && typeof meta.error === "string" ? meta.error : undefined;
    const { label, hidden, required, ...inputProps } = props;

    return (
        <FormFieldRow label={label} error={error} hidden={hidden} required={required}>
            <Input
                {...inputProps}
                id={props.name}
                name={props.name}
                type="number"
                required={required}
                value={field.value ?? ""}
                onChange={field.onChange}
                onBlur={field.onBlur}
                invalid={!!error}
            />
        </FormFieldRow>
    );
};